module.exports = __webpack_public_path__ + "img/jigsaw-back-1.51f1f17a.png";